/**
 * hook: useRouter()
 *
 * Keeps track of all usable routes within the site; all routes are considered
 * external, until they are implemented by this React app.
 *
 * The idea is for this hook to bridge content and functionality migration from
 * the legacy require.js format into the Router component in App.jsx.
 * The goal is for this file to become progressively obsolete as all routes are
 * handled by react itself.
 */

import getLang from 'Utils/getLang';

const { appConfig, location } = window;
const { basePath, restApi } = appConfig;

const routes = {
  download: `/${restApi}/${getLang()}/download/image/:type/:id/:token`,
  mediathek: '/mediathek/:id',
  program: '/programm/:date/:id/',
  search: '/search/:query/',
  webonly_agenda: '/web-only-kalender/',
  account: '/account/',
  account_change_password: '/account-change-password/',
  account_delete: '/account-delete/',
  account_login: '/account-login/',
  account_logout: '/account-logout/',
  account_profile: '/account-profile/',
  account_register: '/account-register/',
  account_register_welcome: '/account-register-welcome/',
  account_verify_email: '/account-verify-email/',
  account_reset_password: '/account-reset-password/',
  account_welcome: '/account-welcome/',
};

// Append correct base path to all routes.
Object.keys(routes).forEach(key => {
  routes[key] = `${basePath}${routes[key]}`;
});

// Find the path for a given route.
const getPath = name => routes[name];

// Appends parts to the path in the correct place.
const buildPath = (name, params) => {
  let path = getPath(name);

  if ( path === undefined ) {
    return '';
  }

  Object.keys(params || {}).forEach(key => {
    if (path.includes(`:${key}`)) {
      path = path.replace(`:${key}`, params[key]);
    }
    else {
      path += `${params[key]}/`;
    }
  });

  path += location.search;

  return path;
};

const external = {
  buildPath,
  getPath,
};

export default () => external;
